// extracted by mini-css-extract-plugin
module.exports = {"logo":"FullDealEntryPointActions_logo__vFswl","buttonFullWidth":"FullDealEntryPointActions_buttonFullWidth__qsWOj"};